import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import { SETTING_ORDERS } from 'modules/notifications/data/settings';
import { getAvailableNotificationExtension } from 'modules/notifications/data/utils';
import { getState as getParent } from 'modules/notifications/selectors/ui';
import { canAccessTo, getUserNotificationConfig } from 'modules/users/selectors/currentUser';

const getRoot = state => state;

const getProps = (_, props) => props;

export const getState = createSelector(getParent, ({ configuration } = {}) => configuration);

export const getSelectedExtension = createSelector(getState, state => state.extension);

const canAccessToPage = createSelector(getRoot, state => canAccessTo(state, PATH.USER_NOTIFICATIONS_SETTINGS.path));

export const getAllExtensions = createSelector(getUserNotificationConfig, configuration => {
  const extensions = getAvailableNotificationExtension(configuration);
  return Object.keys(SETTING_ORDERS).filter(extension => extensions.includes(extension));
});

export const haveNotificationAccess = createSelector(
  getAllExtensions,
  canAccessToPage,
  (extensions, haveAccess) => haveAccess && extensions.length > 0
);

const getConfigurationByExtension = createSelector(
  getUserNotificationConfig,
  getProps,
  (config, extension) => config[extension]
);

export const formatSelectedConfiguration = createSelector(
  getConfigurationByExtension,
  getProps,
  (config, extension) => {
    const availableEventNames = Object.keys(config);

    return SETTING_ORDERS[extension]
      .filter(eventType => availableEventNames.includes(eventType))
      .reduce((acc, eventType) => [...acc, { extension, eventType, ...config[eventType] }], []);
  }
);
